export default "__VITE_ASSET__8d256e07__"